const reCaptcha = (selector) => {
	const SITE_KEY = "6LdNB30sAAAAALwyV1Kc3I4e-0309ZaTxWdD9ihY";
	// document.addEventListener("DOMContentLoaded", () => {
	const forms = document.querySelectorAll(selector || "form");
	
	return new Promise((resolve, reject) => {
		if (!forms) return;
		
		forms.forEach(form => {
			// form.addEventListener("submit", (e) => {
			// e.preventDefault();
			const input = form.querySelector('input[name="g-recaptcha-response"]');
			if (!input) return;
			grecaptcha.ready(() => {
				let action = form.dataset['action'];
				action = action.replace('-', '_');
				grecaptcha.execute(SITE_KEY, {action: action || 'contact_form'}).then((token) => {
					// console.log('reCaptcha token', token);
					// input.value = token;
					resolve(token);
				}).catch((error) => {
					reject(error);
				});
			});
			// });
		});
		// })
	})
}
export {reCaptcha};



// WEBPACK FOOTER //
// ../components/reCaptcha/reCaptcha.js